import React from 'react'
import TabsMui from '../../layout/TabsMui'
import QuoteDetailsTab from './QuoteDetailsTab'
import { QUOTE_SHOW_TABS, QUOTE_STATUS_UI_MAP } from '../helpers/quoteHelpers'

const ShowQuoteView = ({ quote }) => {
  const statusUI = QUOTE_STATUS_UI_MAP[quote?.status] || QUOTE_STATUS_UI_MAP.sent

  if (!quote) return null

  return (
    <>
      <div className="main-show-header">
        <h2>Cotización: {quote.uid || 'N/A'}</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <div className="show-area-tabs-header">
            <TabsMui
              tabs={QUOTE_SHOW_TABS}
              activeTab="quote"
              onChange={() => {}}
              showDivider={false}
              marginBottom={0}
            />
            <div className="status-orders">
              <b className="order-status-b">Estado:</b>
              <span className={`order-status ${statusUI.className}`}>{statusUI.label}</span>
            </div>
          </div>
          <div className="tab-content-area">
            <QuoteDetailsTab quote={quote} />
          </div>
        </div>
      </div>
    </>
  )
}

export default ShowQuoteView
